module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre5",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_vm._v("August Ludolf Friedrich Schauman")]), _vm._v(" "), _c('h1', {
    staticClass: "calibre6"
  }, [_vm._v("ON THE ROAD"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("WITH"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("WELLINGTON")]), _vm._v(" "), _c('h2', {
    staticClass: "calibre7"
  }, [_vm._v("The Diary of a War Commissary")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent"
  }), _vm._v(" "), _c('h3', {
    staticClass: "calibre8"
  }, [_vm._v("New Introduction by Bernard Cornwel")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "calibre1",
    attrs: {
      "alt": "image",
      "src": "images/00003.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54559bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0002.vue
// module id = 63
// module chunks = 0